import type { FC } from 'react';
import { TryWithResourcesWrapper } from './TryWithResources.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface TryWithResourcesProps { }

const TryWithResources: FC<TryWithResourcesProps> = () => (
   <TryWithResourcesWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Try with Resource</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text">
         <ul className="text-align-justify">
            <li>A try statement that declares one or more resources is the try-with-resources statement. The resource it declares is an object that must be closed after finishing the program. </li>
            <li>The try-with-resources statement ensures that each resource is closed at the end of the statement execution automatically. The only condition is that the resources should implement the AutoCloseable interface. It happens regardless of whether any exceptions are thrown either when attempting to close the resources or from inside the try-with-resources block. </li>
            <li>It allows one to declare multiple resources by separating them with a semicolon.</li>
            <li>If a try block throws an exception and one or more exceptions are thrown by the try-with-resources, the exceptions thrown by try-with-resources are suppressed. So they are known as suppressed exceptions. One can get these exceptions by using the getSuppress() method of Throwable class.</li>
            <li>The resources that are defined/acquired first in the try with resources statement, will be closed last. In other words, when multiple resources are opened in try-with-resources, it closes them in the reverse order. This is done to avoid any dependency issues. </li>
            <li>In addition, this block can have the catch and finally blocks as well which will work in the same way as with a traditional try block.</li>
         </ul>
         <br />
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '// Try, Catch, Finally\n' +
               '\n' +
               'Scanner scanner = null;\n' +
               'try {\n' +
               '  scanner = new Scanner(new File("test.txt"));\n' +
               '  PrintWriter writer = new PrintWriter(new File("testWrite.txt"));\n' +
               '  while (scanner.hasNext()) {\n' +
               '    writer.print(scanner.nextLine());\n' +
               '    System.out.println(scanner.nextLine());\n' +
               '  }\n' +
               '} catch (FileNotFoundException e) {\n' +
               '  e.printStackTrace();\n' +
               '} finally {\n' +
               '  if (scanner != null) {\n' +
               '    scanner.close();\n' +
               '  }\n' +
               '}'
            }
         </SyntaxHighlighter>
         <br />
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '//Try with Resources\n' +
               '\n' +
               'try (\n' +
               '  Scanner scanner = new Scanner(new File("test.txt")); \n' +
               '  PrintWriter writer = new PrintWriter(new File("testWrite.txt"))\n' +
               ') {\n' +
               '  while (scanner.hasNext()) {\n' +
               '    writer.print(scanner.nextLine());\n' +
               '    System.out.println(scanner.nextLine());\n' +
               '  }\n' +
               '} catch (FileNotFoundException e) {\n' +
               '  e.printStackTrace();\n' +
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </TryWithResourcesWrapper>
);

export default TryWithResources;
